import { render, staticRenderFns } from "./ScreeningsNew.vue?vue&type=template&id=668633c2&scoped=true&"
import script from "./ScreeningsNew.vue?vue&type=script&lang=js&"
export * from "./ScreeningsNew.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsNew.vue?vue&type=style&index=0&id=668633c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668633c2",
  null
  
)

export default component.exports